import React, { Component } from "react";
import { ReduxConnect, Router } from "../../../../toolkit/decorators/Artifact";
import { Helmet } from "react-helmet";
import IntegranteResolucionComponent from "../../../components/comisionesMembresia/integranteResolucion/IntegranteResolucion";
import {
  IntegranteResolucionStore,
  integranteResolucionStore
} from "./IntegranteResolucion.store";
import {
  IntegranteResolucionDispatcher,
  integranteResolucionDispatcher
} from "./IntegranteResolucion.dispatcher";
import Layout from "../../../components/layout";

interface Props
  extends IntegranteResolucionStore,
    IntegranteResolucionDispatcher {}
interface State {}

@Router()
@ReduxConnect(integranteResolucionStore, integranteResolucionDispatcher)
export default class IntegranteResolucionContainer extends Component<
  Props,
  State
> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Resoluciones de Altas de Integrantes - Membresías" />
          <IntegranteResolucionComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
